import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import Button from '@material-ui/core/Button';

import {
  DROP_NOTIFICATION_REQUESTED,
  DROP_NOTIFICATION_SUCCESSFULL,
  DROP_NOTIFICATION_ERRORED
} from '../redux/actions/types';
import { requestNotification } from '../redux/actions/product';
import AdornedButton from './AdornedButton';
import RTVDialog from './dialogs/RTVDialog';
import { withRouter } from 'react-router';
import { expressToggle } from '../redux/actions/app';

const RTVNotifyAvailability = ({
  status,
  requestNotification,
  product,
  user,
  buttonProps,
  push,
  location,
  expressToggle
}) => {
  const [loading, setLoading] = React.useState(false);
  const [dialog, setDialog] = React.useState({
    open: false,
    content: {}
  });

  React.useEffect(() => {
    if (status === DROP_NOTIFICATION_REQUESTED) {
      setLoading(true);
    }
    if (status === DROP_NOTIFICATION_SUCCESSFULL) {
      setLoading(false);
      setDialog({
        open: true,
        content: {
          title: 'Listo! Te avisamos si vuelve a estar disponible ',
          message: 'Estate atenta!',
          actionSection: (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setDialog({ open: false, content: {} })}
            >
              OK
            </Button>
          )
        }
      });
    }
    if (status === DROP_NOTIFICATION_ERRORED) {
      setLoading(false);
      setDialog({
        open: true,
        content: {
          title: 'Uups!',
          message:
            'Parece que hubo un error al intentar subscribirme a esta notificacion!'
        }
      });
    }
  }, [status]);

  const onClickHandler = () => {
    if (!user) {
      expressToggle(true, { entity: 'Product', identifier: product?.id });
      return;
    }

    requestNotification(product, user);
  };

  return (
    <>
      <RTVDialog
        open={dialog.open}
        onClose={() => setDialog({ open: false, content: {} })}
        {...dialog.content}
      />
      {product.waiting_on_reservation_drop.find(
        u => user && u.id === user.id
      ) === undefined && (
        <AdornedButton
          loading={loading}
          disabled={loading}
          {...buttonProps}
          onClick={
            user
              ? () => requestNotification(product, user)
              : () => onClickHandler()
          }
        >
          AVISARME SI SE LIBERA
        </AdornedButton>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  status: state.product.status
});

const mapDispatchToProps = dispatch => ({
  requestNotification: (product, user) =>
    dispatch(requestNotification(product, user)),
  push: path => dispatch(push(path)),
  expressToggle: (toggle, fromAction) =>
    dispatch(expressToggle(toggle, fromAction))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RTVNotifyAvailability));
